export default __webpack_public_path__ + "static/media/1514.970b5010.png";